import React__default, { useContext, useCallback, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { IS_PROD_ENV } from '../../utilities/env.mjs';
import { filterUnsupportedClassNames, TransitionGroupManagerError, TransitionContainerViolation } from './utilities.mjs';
import { useMediaQuery } from '../MediaQueryProvider/MediaQueryProvider.mjs';
import { TransitionContext } from '../TransitionGroupManager/TransitionGroupManager.mjs';

function TransitionContainer({
  children,
  sharedTransition = false,
  transitionClassNames = {},
  onEnter,
  onExited
}) {
  const {
    prefersReducedMotion
  } = useMediaQuery();
  const transitionContext = useContext(TransitionContext);
  reportDevRenderErrors(transitionContext, sharedTransition);
  const contextOnExited = transitionContext === null || transitionContext === void 0 ? void 0 : transitionContext.onExited;
  const handleOnExited = useCallback(node => {
    onExited === null || onExited === void 0 ? void 0 : onExited(node);
    contextOnExited === null || contextOnExited === void 0 ? void 0 : contextOnExited(node);
  }, [onExited, contextOnExited]);
  const show = transitionContext ? transitionContext.in : true;
  const childTransitionContext = useMemo(() => {
    if (transitionContext == null) {
      return null;
    }
    return {
      ...transitionContext,
      depth: transitionContext.depth + 1
    };
  }, [transitionContext]);
  return /*#__PURE__*/React__default.createElement(CSSTransition, {
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    classNames: filterUnsupportedClassNames(transitionClassNames),
    in: show,
    timeout: {
      enter: 0,
      exit: prefersReducedMotion ? 0 : 200
    },
    onEnter: onEnter,
    onExited: handleOnExited
  }, /*#__PURE__*/React__default.createElement(TransitionContext.Provider, {
    value: childTransitionContext
  }, children));
}
function reportDevRenderErrors(context, shared = false) {
  if (IS_PROD_ENV) {
    return;
  }
  if (context == null) {
    console.error(new TransitionGroupManagerError(TransitionContainerViolation.MissingContextProvider));
  } else if (context.depth > 0 && !shared) {
    console.error(new TransitionGroupManagerError(TransitionContainerViolation.NotShared));
  }
}

export { TransitionContainer };
